import { Grid } from '@mui/material';

import { BasePage } from 'main/components/_common/BasePage';
import { ContactNotes } from './ContactNotes';
import { ContactForm } from './ContactForm';

export const ContactPage = () => {
    return (
        <BasePage title="お問い合わせ">
            <Grid container direction="column">
                <Grid item>
                    <ContactNotes />
                </Grid>
                <Grid item>
                    <ContactForm />
                </Grid>
            </Grid>
        </BasePage>
    )
}
